import { GET_BLOG_CATEGORY_AND_SUBCATEGORY } from "../../store/constants/blogConstants";
import { GET_HOME_PAGE_DATA, GET_OLD_HOME_PAGE_DATA } from "./constants";

const init = {
  home_data: {},
  old_home_data: {},
  blog_category_subcategory: [],
};

const homeReducers = (state = init, action) => {
  switch (action.type) {
    case GET_HOME_PAGE_DATA: {
      return {
        ...state,
        home_data: action.payload.data,
      };
    }
    case GET_OLD_HOME_PAGE_DATA: {
      return {
        ...state,
        old_home_data: action.payload.data,
      };
    }
    case GET_BLOG_CATEGORY_AND_SUBCATEGORY: {
      return {
        ...state,
        blog_category_subcategory: action.payload,
      };
    }
    default:
      return state;
  }
};
export default homeReducers;
